import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useBatchTicketInvestLink } from '../../hooks/BatchTicketInvestLink';

import { ConfirmationFeedback } from './components/ConfirmationFeedback';
import { ContainerDesktop } from './Desktop';
import { ContainerMobile } from './Mobile';

export interface CustomerOffersProps {}

export const CustomerOffers: React.FC<CustomerOffersProps> = () => {
  const {
    retryBatchTicketInvestLink,
    handleConfirmOrder,
    handleRefuseOrder,
    handleToggleOrderStatus,
    handleRedirectWhatsapp,
    listBatchTicketLink,
    errorBatchTicketLink,
    loadingBatchTicketLink,
    offersInfoData,
    isConfirmedOrder,
  } = useBatchTicketInvestLink();

  const responsiveContainer = useBreakpointValue({
    base: (
      <ContainerMobile
        retryBatchTicketInvestLink={retryBatchTicketInvestLink}
        handleConfirmOrder={handleConfirmOrder}
        handleRefuseOrder={handleRefuseOrder}
        handleToggleOrderStatus={handleToggleOrderStatus}
        listBatchTicketLink={listBatchTicketLink}
        errorBatchTicketLink={errorBatchTicketLink}
        loadingBatchTicketLink={loadingBatchTicketLink}
        offersInfoData={offersInfoData}
      />
    ),
    sm: (
      <ContainerDesktop
        retryBatchTicketInvestLink={retryBatchTicketInvestLink}
        handleConfirmOrder={handleConfirmOrder}
        handleRefuseOrder={handleRefuseOrder}
        handleToggleOrderStatus={handleToggleOrderStatus}
        listBatchTicketLink={listBatchTicketLink}
        errorBatchTicketLink={errorBatchTicketLink}
        loadingBatchTicketLink={loadingBatchTicketLink}
        offersInfoData={offersInfoData}
      />
    ),
  });

  if (isConfirmedOrder) {
    return <ConfirmationFeedback handleRedirectWhatsapp={handleRedirectWhatsapp} />;
  }

  return responsiveContainer;
};
